import React from "react";
import MasterModule from "../MasterModule";
import EnquiryStages from "./EnquiryStages";
import { CRM_AUTH } from "../../../config/authorizationConfig";

// Module configuration
const crmModules = [
  {
    name: "Enquiry Stages",
    component: EnquiryStages,
    authConfig: CRM_AUTH.MANAGE_ENQUIRY_STAGES,
  },
];

// API endpoints mapping
const crmApiEndpoints = {
  "Enquiry Stages": "/enquiry-stages",
};

// Custom URL builder for CRM
const getCrmApiUrl = (endpoint) => {
  return `${process.env.REACT_APP_API_CRM_ADMIN_URL}${endpoint}`;
};

const CrmMaster = () => {
  return (
    <MasterModule
      title="CRM Modules"
      modules={crmModules}
      apiEndpoints={crmApiEndpoints}
      getApiUrl={getCrmApiUrl}
    />
  );
};

export default CrmMaster;
